import { render, staticRenderFns } from "./134.vue?vue&type=template&id=6fd0486a&scoped=true&"
import script from "./134.vue?vue&type=script&lang=js&"
export * from "./134.vue?vue&type=script&lang=js&"
import style0 from "./134.vue?vue&type=style&index=0&id=6fd0486a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd0486a",
  null
  
)

export default component.exports